// Components
import * as mainLeftNav from './components/main-left-nav.js';
import * as passwordInput from './components/password-input.js';
import * as charactersCount from './components/characters-count.js';
import * as header from './components/header.js';
import * as carousel_type1 from './carousels/type-1.js';
import * as carousel_type2 from './carousels/type-2.js';
import * as fadeWindowBasic from './components/faded-windows/fade-window-basic.js';
import * as fade_window_2 from './components/faded-windows/fade-window-2.js';
import * as carousel_type3 from './carousels/type-3.js';
import * as cardset from './components/cardset.js';
import * as carousel_type4 from './carousels/type-4.js';
import * as mediaContainer from './components/media-container.js';
import * as videoloader from './components/video-loading.js';
import * as lazyLoadingCarousels from './components/lazy-loading-carousels.js';
import * as breadcrumb from './components/breadcrumb.js';
import * as carousel_type5 from './carousels/type-5.js';
import * as carousel_type6 from './carousels/type-6.js';
import * as carousel_type7 from './carousels/type-7.js';
import * as carousel_type8 from './carousels/type-8.js';
import * as carousel_type9 from './carousels/type-9.js';
import * as carousel_type10 from './carousels/type-10.js';
import * as carousel_type11 from './carousels/type-11.js';
import * as carousel_type12 from './carousels/type-12.js';
import * as carousel_type13 from './carousels/type-13.js';
import * as carousel_type14 from './carousels/type-14.js';
import * as carousel_type15 from './carousels/type-15.js';
import * as carousel_type16 from './carousels/type-16.js';
import * as productGallery from './components/product-gallery.js';
import * as imageLinkGallery from './components/image-link-gallery.js';
import * as submenu from './components/submenu.js';
import * as footer from './components/footer.js';
import * as countdown from './components/countdown.js';
import * as accordion from './components/accordion.js';
import * as switcherTab from './components/switcher-tab.js';
import * as switcherTab2 from './components/switcher-tab-2.js';
import * as counter from './components/counter.js';
import * as videoPlayOnScroll from './components/video-play-on-scroll.js';
import * as api from './components/api.js';
import * as animatedVideoAftScrll from './components/animated-video-aft-scrll';
import * as multigallery from './components/multigallery.js';
import * as newFeatures from './components/new-features.js';
import * as rating from './components/rating.js';
import * as floatingPagination from './components/floating-pagination.js';
import * as modelBox from './components/model-box.js';
import * as filter from './components/filter.js';
import * as comparisonTable from './components/comparison-table.js';
import * as goToCms from './components/go-to-cms.js';
import * as componentOptions from './components/component-options.js';
import * as boxDynamic from './components/dynamic-box.js';
import * as prism from './libraries/prism.js';
import * as modelsPageResponsive from './pages/modelsPageResponsive.js'
import * as mainContentWrapper from './components/main-content-wrapper.js'
import * as webshopProductSection from './components/webshop-product-section.js'
import * as gridItem from './components/grid-item.js'
import * as shareWindow from './components/share-window.js'
import * as youtubeVideo from './components/youtube-video.js'
import * as navigators from './components/navigators.js'
import * as globalScripts from './components/faded-windows/global-for-faded-windows.js'
import * as onlineManuals from './components/online-manuals.js'
import * as miaDecoration from './components/mia-mouse-circle-decoration.js'
import * as comparisonBoxSet from './components/comparison-box-set.js'
import * as CardBannerSet from './components/card-banner-set.js'
import * as slideToAnchor from './helpers/slide-to-anchor.js'
import * as labels from './components/labels.js'
import * as audioPlayer from './components/audio-player.js'
import * as customGPT from './components/custom-gpt.js'
import * as menuPage from './components/menu-page.js'
import * as expandableSet from './components/expandable-set.js'
import * as enhancedContactBoxSet from './components/enahnced-contact-box-set.js'
import * as bannerV from './components/banner-v.js'
import * as customerProjectDetailPageResponsive from './pages/customerProjectDetailResponsive.js'
import * as accordionSelfBasic from './components/accordion-self-basic.js';
import * as filterSingleSelectByNumber from './utilities/filters/filterSingleSelectByNumber.js';
import * as fontLoading from './libraries/fonts.js'
// content load components 
const componentsload = [];

// once delegated components
const components = [
	fontLoading,
	mainLeftNav,
	passwordInput,
	carousel_type15,
	charactersCount,
	header,
	carousel_type1,
	carousel_type2,
	fade_window_2,
	carousel_type3,
	carousel_type4,
	carousel_type5,
	carousel_type6,
	carousel_type7,
	carousel_type8,
	carousel_type9,
	carousel_type10,
	carousel_type11,
	carousel_type12,
	carousel_type13,
	carousel_type14,
	carousel_type16,
	mediaContainer,
	rating,
	accordion,
	breadcrumb,
	modelBox,
	labels,
	comparisonBoxSet,
	CardBannerSet,
	cardset,
	productGallery,
	api,
	animatedVideoAftScrll,
	customerProjectDetailPageResponsive,
	mainContentWrapper,
	gridItem,
	imageLinkGallery,
	multigallery,
	floatingPagination,
	menuPage,
	onlineManuals,
	customGPT,
	switcherTab,
	switcherTab2,
	countdown,
	submenu,
	filter,
	comparisonTable,
	navigators,
	footer,
	boxDynamic,
	fadeWindowBasic,
	counter,
	videoPlayOnScroll,
	webshopProductSection,
	newFeatures,
	goToCms,
	componentOptions,
	prism,
	modelsPageResponsive,
	shareWindow,
	filterSingleSelectByNumber,
	globalScripts,
	enhancedContactBoxSet,
	slideToAnchor,
	expandableSet,
	audioPlayer,
	miaDecoration,
	youtubeVideo,
	bannerV,
	accordionSelfBasic,
	videoloader,
	lazyLoadingCarousels  //this has to be called after all carousels, where this is implemented
].concat(componentsload);

window.App = {
	apiMethod: "POST",
	run() {
		const $target = document;
		components.forEach((component) => component.init($target));
		document.addEventListener('DOMContentLoaded', (event) => {
			const $eventTarget = event.target;
			componentsload.forEach((component) => component.init($eventTarget));
		});
	},
	initComponent(component) {
		return component.init();
	},
};

